<script setup lang="ts">

</script>

<template>
<div class="bg-metal-900 text-metal-300 flex-grow">
  <slot></slot>
</div>
</template>

<style scoped lang="scss">

</style>